import React from 'react'
import {useController, useSuspense} from '@data-client/react'
import {TripResource} from '../lib/model'
import {PageProps} from '../components/PageRouter'
import {Box, Button, IconButton, Typography} from '@mui/material'
import {IconDelete, IconExport, IconInfo, IconMenu, IconSearch, IconShare, IconUpdate, IconUploadFotos} from '../Icons'
import {TripNav, TripView} from '../components/Trip'

import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-thumbnail.css'
import 'lightgallery/css/lg-autoplay.css'
import 'lightgallery/css/lg-fullscreen.css'
import {useToggle} from '../lib'
import {Collapse} from '../components'
import {FotoUploader} from '../components/Fotos'

export default function TripMapPage({params}: PageProps) {
  const trip = useSuspense(TripResource.get, {id: params['id']})
  const search = useToggle()
  const api = useController()
  React.useEffect(() => {
    if (trip.fotos.length === 0 && trip.children.length === 0) {
      try {
        api.invalidate(TripResource.get, {id: trip.id})
      } catch {
        // ignore for now since this useEffect is a temporary workaround
      }
    }
  }, [api, trip.id, trip.fotos.length, trip.children.length])

  return (
    <TripView trip={trip}>
      <Box
        maxWidth="1000px"
        sx={{
          position: 'relative',
          mt: '10px',
          ml: {xs: '10px', sm: '20px', lg: 'auto'},
          mr: {xs: '50px', sm: '60px', lg: 'auto'},
        }}
      >
        <Box bgcolor="rgba(225, 225, 225, 0.8)" borderRadius={1}>
          <Collapse>
            <Box display="flex" alignItems="center">
              <Button color="primary" title="Trip Actions" sx={{pr: 0}}>
                <IconMenu />
              </Button>
              <Typography variant="h3" py={1} color="primary">
                {trip.title}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-around">
              <IconButton title="Other Trips" onClick={search.toggle} color="primary">
                <IconSearch />
              </IconButton>
              <IconButton title="Trip Details" href={`/trip/${trip.id}-${trip.slug}/`} color="primary">
                <IconInfo />
              </IconButton>
              <IconButton href={`./update`} color="primary" title="Update Trip">
                <IconUpdate />
              </IconButton>
              <FotoUploader trip={trip}>
                <IconUploadFotos />
              </FotoUploader>
              {trip.fotos.length > 0 && (
                <>
                  <IconButton href={`./export`} color="primary" title="Export Trip">
                    <IconExport />
                  </IconButton>
                  <IconButton href={`./share`} color="primary" title="Share Trip">
                    <IconShare />
                  </IconButton>
                </>
              )}
              <IconButton href={`./delete`} color="primary" title="Delete Trip">
                <IconDelete />
              </IconButton>
            </Box>
          </Collapse>
        </Box>
        {search.enabled && <TripNav defval={trip.id} />}
      </Box>
    </TripView>
  )
}
